import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddUserActivityMutationVariables = Types.Exact<{
  input: Types.User_Activities_Insert_Input;
}>;


export type AddUserActivityMutation = { __typename?: 'mutation_root', insert_user_activities_one?: { __typename?: 'user_activities', id: any, user_id: string, entity: string, entity_id: string, event_type: string, created_at: any } | null };


export const AddUserActivityDocument = gql`
    mutation addUserActivity($input: user_activities_insert_input!) {
  insert_user_activities_one(object: $input) {
    id
    user_id
    entity
    entity_id
    event_type
    created_at
  }
}
    `;
export type AddUserActivityMutationFn = Apollo.MutationFunction<AddUserActivityMutation, AddUserActivityMutationVariables>;

/**
 * __useAddUserActivityMutation__
 *
 * To run a mutation, you first call `useAddUserActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserActivityMutation, { data, loading, error }] = useAddUserActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddUserActivityMutation(baseOptions?: Apollo.MutationHookOptions<AddUserActivityMutation, AddUserActivityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserActivityMutation, AddUserActivityMutationVariables>(AddUserActivityDocument, options);
      }
export type AddUserActivityMutationHookResult = ReturnType<typeof useAddUserActivityMutation>;
export type AddUserActivityMutationResult = Apollo.MutationResult<AddUserActivityMutation>;
export type AddUserActivityMutationOptions = Apollo.BaseMutationOptions<AddUserActivityMutation, AddUserActivityMutationVariables>;